/** Minimal conditional-className joiner. Avoids a dependency for 12 lines. */
export type ClassValue = string | false | null | undefined;

export function clsx(...values: ClassValue[]): string {
  let out = '';
  for (const v of values) {
    if (typeof v === 'string' && v !== '') out += out === '' ? v : ` ${v}`;
  }
  return out;
}
